module.exports = __webpack_public_path__ + "img/small-3.977673dc.jpg";